import { SearchOutlined } from '@ant-design/icons'
import styled from '@emotion/styled'
import { Input as AntdInput, Form, Col, Input, DatePicker } from 'antd'

export const ColAntd = styled(Col)``

export const Container = styled('div')`
  padding: 32px;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  background-color: white;
`

export const Title = styled('div')`
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 32px;
`

export const LabelOptional = styled('div')`
  color: #adadad;
  font-weight: 400;
  padding-left: 5px;
`
export const FormItem = styled(Form.Item)`
  .ant-form-item-label > label {
    font-weight: 500;
    color: #374151;
  }

  .ant-form-item-required::before {
    display: none !important;
  }
`

export const SearchIcon = styled(SearchOutlined)`
  color: #adadad;
`
export const SearchInput = styled(AntdInput.Search)``

export const PageContainer = styled.div`
  padding: 1.5rem; /* p-6 */
  background-color: #f3f4f6; /* bg-gray-100 */
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Inter', sans-serif; /* font-inter */
`

export const StyledInput = styled(Input)`
  border-radius: 0.375rem; /* rounded-md */
`

export const StyledDatePicker = styled(DatePicker)`
  width: 100%;
  border-radius: 0.375rem; /* rounded-md */
`

export const StyledForm = styled(Form)`
  & > div {
    /* Target direct children of Form for space-y-4 */
    margin-bottom: 1rem;
  }
  & > div:last-child {
    margin-bottom: 0;
  }

  /* Override Ant Design Form classes */
  .ant-form-item {
    margin-bottom: 16px;
  }

  .ant-form-item-label {
    padding-bottom: 4px;
  }

  .ant-form-item-label > label {
    font-weight: 500;
    color: #374151;
  }

  /* Hide required asterisk */
  .ant-form-item-required::before {
    display: none !important;
  }

  /* Custom required asterisk style */
  .ant-form-item-required::after {
    content: ' *';
    color: #ef4444;
    font-weight: bold;
  }

  /* Style form validation messages */
  .ant-form-item-explain-error {
    color: #ef4444;
    font-size: 14px;
  }

  /* Style input focus state */
  .ant-input:focus,
  .ant-input-focused {
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
  }

  /* Style date picker */
  .ant-picker {
    width: 100%;
    border-radius: 0.375rem;
  }

  .ant-picker:focus,
  .ant-picker-focused {
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
  }
`
export const BoxLabel = styled('div')`
  display: flex;
`
export const HeadTitle = styled('div')`
  font-size: 16px;
  font-weight: 500;
  color: #000000;
`
export const RequiredAsterisk = styled.span`
  color: #ef4444; /* text-red-500 */
`
